import { Thought } from "@/interfaces/copilotTypes";
import { useTranslation } from "next-i18next";
import { memo } from "react";

interface Props {
  thoughts?: Thought[];
}

const ThoughtAnalysis = memo(
  (props: Props) => {
    const { t } = useTranslation("copilot");

    const renderText = () => {
      const analysIsFinished =
        Array.isArray(props.thoughts) &&
        props.thoughts.every((thought) => thought.status === "final");

      return analysIsFinished
        ? t("i-have-completed-my-analysis")
        : t("let-me-collect-my-thoughts-before-i-reply") + "...";
    };

    return (
      <span className="flex-1 px-3 font-bold leading-6">{renderText()}</span>
    );
  },
  (pre, next) => pre === next
);

ThoughtAnalysis.displayName = "ThoughtAnalysis";
export default ThoughtAnalysis;
